import { teams } from './teamList';

// Derived from the /get-full-schedule response (a flat list of every game in the
// season: {week, away, home, kickoff_utc, deadline_utc, deadline_label}). Only
// populated for years with a dynamically-synced schedule (2026+) -- historical
// years get an empty array back and these helpers just return empty results,
// which callers treat as "this feature has no data for this season" rather than
// an error.

// A team's full-season schedule, one entry per week they play, sorted by week.
export function getTeamSchedule(games, team) {
    return games
        .filter((g) => g.away === team || g.home === team)
        .map((g) => ({
            week: g.week,
            opponent: g.away === team ? g.home : g.away,
            isHome: g.home === team,
            kickoffUtc: g.kickoff_utc,
            deadlineLabel: g.deadline_label,
        }))
        .sort((a, b) => a.week - b.week);
}

// Every real team's bye week (the one week 1-18 they don't appear in `games`),
// as {TeamName: weekNum}. Teams with no detectable bye (incomplete schedule
// data, e.g. only some weeks synced so far) are simply omitted rather than
// guessed at.
export function getByeWeeks(games) {
    if (!games || games.length === 0) return {};

    const weeksPresent = [...new Set(games.map((g) => g.week))];
    if (weeksPresent.length === 0) return {};
    const maxWeek = Math.max(...weeksPresent);

    const byeWeeks = {};
    teams.forEach((team) => {
        if (team === 'Team') return; // placeholder entry, not a real team
        const playedWeeks = new Set(
            games.filter((g) => g.away === team || g.home === team).map((g) => g.week)
        );
        if (playedWeeks.size === 0) return; // no data for this team yet
        for (let w = 1; w <= maxWeek; w++) {
            if (!playedWeeks.has(w)) {
                byeWeeks[team] = w;
                break;
            }
        }
    });
    return byeWeeks;
}
